import { TApplicationState } from '../../types/redux';

export const getNewbuildingReviewsStat = (state: TApplicationState) => {
  return state.newbuilding.reviews;
};
